'use client';

import { FrontendBroker } from '@trucksmarter/shared';
import DallasText from '~/app/_ui/Dallas/Text/DallasText';
import { EMPTY_VALUE_PLACEHOLDER } from '~/app/_ui/shared/text-placeholders';
import { Props as DallasTextProps } from '~/app/_ui/Dallas/Text/DallasText';
import DallasTooltipAnchor from '~/app/_ui/Dallas/Tooltip/DallasTooltipAnchor';

import styles from './BrokerDisplayLogo.module.scss';

interface Props {
  className?: string;
  broker?: Pick<FrontendBroker, 'logoUrl' | 'logoAspectRatio' | 'displayName'>;
  textNoWrap?: boolean;
  textVariant?: DallasTextProps['variant'];
}

export default function BrokerDisplayLogo({
  className,
  broker,
  textNoWrap = false,
  textVariant = 'body',
}: Props) {
  const { logoUrl, logoAspectRatio, displayName } = broker || {};
  const content = logoUrl ? (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      className={styles.logo}
      src={logoUrl}
      alt={displayName}
      style={{
        aspectRatio: logoAspectRatio,
      }}
    />
  ) : (
    <DallasText variant={textVariant} noWrap={textNoWrap}>
      {displayName || EMPTY_VALUE_PLACEHOLDER}
    </DallasText>
  );

  return displayName ? (
    <DallasTooltipAnchor
      tooltipType="label"
      tooltip={displayName}
      render={(props) => <div {...props} className={className} />}
    >
      {content}
    </DallasTooltipAnchor>
  ) : (
    <div className={className}>{content}</div>
  );
}
